import { useRef, useSyncExternalStore } from 'react';

import {
  workspaceHighlightColor,
  workspaceHighlightWash
} from '@/components/userDashboard/workflowsCards/safeColor';
import { useRouteWorkspace } from '@/hooks/useRouteWorkspace';

let overrideColor: string | null = null;
const listeners = new Set<() => void>();

export const setWorkspaceHighlightOverride = (color: string | null) => {
  if (overrideColor === color) {
    return;
  }
  overrideColor = color;
  for (const listener of listeners) {
    listener();
  }
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
const getOverride = () => overrideColor;

export const useWorkspaceHighlight = () => {
  const override = useSyncExternalStore(subscribe, getOverride, getOverride);
  const { workspace, isWorkspaceRoute, loading, error } = useRouteWorkspace();

  const lastColor = useRef<string | null>(null);
  const lastInWorkspace = useRef(false);
  if (!loading) {
    lastColor.current = override ?? workspace?.color ?? null;
    lastInWorkspace.current = Boolean(workspace);
  }
  const rawColor = lastColor.current;
  const color = workspaceHighlightColor(rawColor);

  return {
    color,
    wash: workspaceHighlightWash(rawColor),
    active: Boolean(color),
    inWorkspace: lastInWorkspace.current,
    workspace,
    isWorkspaceRoute,
    loading,
    error
  };
};
